const pad2 = (value: number): string => String(value).padStart(2, '0');

const parsePeselDateParts = (pesel: string): { year: number; month: number; day: number } | null => {
  if (!/^\d{11}$/.test(pesel)) {
    return null;
  }

  const yy = Number(pesel.slice(0, 2));
  const monthWithCentury = Number(pesel.slice(2, 4));
  const day = Number(pesel.slice(4, 6));

  let year = 0;
  let month = 0;

  if (monthWithCentury >= 1 && monthWithCentury <= 12) {
    year = 1900 + yy;
    month = monthWithCentury;
  } else if (monthWithCentury >= 21 && monthWithCentury <= 32) {
    year = 2000 + yy;
    month = monthWithCentury - 20;
  } else if (monthWithCentury >= 41 && monthWithCentury <= 52) {
    year = 2100 + yy;
    month = monthWithCentury - 40;
  } else if (monthWithCentury >= 61 && monthWithCentury <= 72) {
    year = 2200 + yy;
    month = monthWithCentury - 60;
  } else if (monthWithCentury >= 81 && monthWithCentury <= 92) {
    year = 1800 + yy;
    month = monthWithCentury - 80;
  } else {
    return null;
  }

  return { year, month, day };
};

export const decodePeselBirthdate = (pesel: string): string | null => {
  const parsed = parsePeselDateParts(pesel);
  if (!parsed) {
    return null;
  }

  const { year, month, day } = parsed;
  const candidate = new Date(Date.UTC(year, month - 1, day));

  if (
    candidate.getUTCFullYear() !== year ||
    candidate.getUTCMonth() !== month - 1 ||
    candidate.getUTCDate() !== day
  ) {
    return null;
  }

  return `${pad2(day)}.${pad2(month)}.${year}`;
};

export const isBirthdateWithinAgeRange = (birthdate: string, min: number, max: number, now = new Date()): boolean => {
  const [day, month, year] = birthdate.split('.').map(Number);
  if (!day || !month || !year) {
    return false;
  }

  const birth = new Date(Date.UTC(year, month - 1, day));
  if (
    birth.getUTCFullYear() !== year ||
    birth.getUTCMonth() !== month - 1 ||
    birth.getUTCDate() !== day
  ) {
    return false;
  }

  const currentYear = now.getUTCFullYear();
  const currentMonth = now.getUTCMonth();
  const currentDay = now.getUTCDate();

  let age = currentYear - year;
  const hadBirthday = currentMonth > month - 1 || (currentMonth === month - 1 && currentDay >= day);
  if (!hadBirthday) {
    age -= 1;
  }

  return age >= min && age <= max;
};


